import {useState} from "react";
import {printReceipt} from '../Helpers/receipt'
import {processAxiosError, showError, showSuccess} from "../utils/helper";
import {getPdf} from "../Helpers/pdf";
import HeaderTop from "../Components/HeaderTop";
import PartialStornoModal from "../Components/PartialStornoModal";


export default function SearchInvoice() {

    const [processing, setProcessing] = useState(false)

    // Invoice search
    const [searchQuery, setSearchQuery] = useState('')
    const [searching, setSearching] = useState(false)
    const [searchResults, setSearchResults] = useState([])
    const [expandedResult, setExpandedResult] = useState(null)
    const [searchError, setSearchError] = useState('')

    // Storno confirmation modal
    const [showStornModal, setShowStornModal] = useState(false)
    const [stornSaleItem, setStornSaleItem] = useState(null)

    // Partial storno modal
    const [showPartialStornoModal, setShowPartialStornoModal] = useState(false)
    const [partialStornoSale, setPartialStornoSale] = useState(null)

    const hasCardPayment = (item) => {
        return item.card_gateway_payment_id && !item.card_refunded
    }

    const handleSearch = async (e) => {
        e.preventDefault()
        if (!searchQuery.trim()) return

        setSearching(true)
        setSearchResults([])
        setExpandedResult(null)
        setSearchError('')

        try {
            const { data } = await window.axios.get('/sales/search', { params: { q: searchQuery.trim() } })
            if (data.success) {
                setSearchResults(data.data)
            } else {
                setSearchError(data.error || 'Račun nije pronađen.')
            }
        } catch (err) {
            if (err.response?.status === 404) {
                setSearchError('Račun nije pronađen.')
            } else {
                setSearchError(err.response?.data?.error || 'Greška pri pretrazi.')
            }
        }

        setSearching(false)
    }

    const clearSearch = () => {
        setSearchQuery('')
        setSearchResults([])
        setExpandedResult(null)
        setSearchError('')
    }

    const openStornModal = (item) => {
        setStornSaleItem(item)
        setShowStornModal(true)
    }

    const closeStornModal = () => {
        setShowStornModal(false)
        setStornSaleItem(null)
    }

    const confirmStorn = async () => {
        if (!stornSaleItem) return

        setProcessing(true)
        setShowStornModal(false)

        await window.axios.delete('/sales/' + stornSaleItem.id)
            .then((response) => {
                setProcessing(false)

                if (response.status === 201 && response.data.success === true) {
                    setSearchResults(prev => prev.map(s => s.id === stornSaleItem.id ? {...s, status: 0} : s))
                    setExpandedResult(null)

                    if (response.data.data) {
                        printReceipt(response.data.data)
                    }

                    if (response.data.card_refund_success) {
                        showSuccess('Račun storniran i povrat na karticu izvršen!')
                    } else if (response.data.card_refund_error) {
                        showError('Račun storniran, ali povrat na karticu nije uspio: ' + response.data.card_refund_error)
                    } else {
                        showSuccess('Račun uspješno stoniran!')
                    }
                } else {
                    showError('Došlo je do greške! Error: ' + response.status)
                }
            })
            .catch((error) => {
                setProcessing(false)
                processAxiosError(error)
            })

        setStornSaleItem(null)
    }

    return (
        <>
            <HeaderTop title={'Pretraga računa'}/>
            <div className="w-full h-full flex flex-column" style={{minHeight: `calc(100vh - 80px)`}}>
                <div className="w-full flex-grow flex">
                    <div className="flex flex-col bg-blue-gray-50 h-full w-full">
                        <div className="h-full overflow-hidden mt-4">
                            <div className="w-full flex flex-col bg-blue-gray-50 h-full bg-white pr-4 pl-2 mb-4">
                                <div className="bg-white rounded-sm flex flex-col h-full shadow px-4 py-4">
                                    <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight mb-4">Pretraga računa</h2>

                                    <div className="mb-4 bg-white rounded-lg shadow p-4">
                                        <form onSubmit={handleSearch} className="flex items-center gap-3">
                                            <div className="flex-grow relative">
                                                <input
                                                    type="text"
                                                    value={searchQuery}
                                                    onChange={e => setSearchQuery(e.target.value)}
                                                    placeholder="Pretraži po broju računa..."
                                                    className="w-full px-4 py-2.5 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                                                />
                                                {searchQuery && (
                                                    <button type="button" onClick={clearSearch}
                                                        className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
                                                        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                                        </svg>
                                                    </button>
                                                )}
                                            </div>
                                            <button type="submit" disabled={searching || !searchQuery.trim()}
                                                className="px-6 py-2.5 bg-primary hover:bg-yellow-600 text-black font-medium rounded-lg transition-colors disabled:opacity-50">
                                                {searching ? 'Tražim...' : 'Traži'}
                                            </button>
                                        </form>

                                        {/* Search error */}
                                        {searchError && (
                                            <div className="mt-3 p-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-600">
                                                {searchError}
                                            </div>
                                        )}

                                        {/* Search results */}
                                        {searchResults.length > 0 && (
                                            <div className="mt-3 border border-gray-200 rounded-lg overflow-hidden">
                                                <div className="bg-gray-50 px-4 py-2.5 border-b border-gray-200 flex justify-between items-center">
                                                    <h4 className="font-semibold text-gray-700 text-sm">
                                                        Pronađeno: {searchResults.length} {searchResults.length === 1 ? 'račun' : 'računa'}
                                                    </h4>
                                                    <button onClick={clearSearch} className="text-gray-400 hover:text-gray-600 text-xs">Zatvori</button>
                                                </div>

                                                {searchResults.map((sale) => (
                                                    <div key={sale.id} className="border-b border-gray-100 last:border-b-0">
                                                        <div
                                                            className="px-4 py-3 flex items-center justify-between cursor-pointer hover:bg-gray-50"
                                                            onClick={() => setExpandedResult(expandedResult === sale.id ? null : sale.id)}
                                                        >
                                                            <div className="flex items-center gap-4 flex-grow">
                                                                <div className="text-sm font-medium text-gray-800 w-32">{sale.invoice_real_id || '-'}</div>
                                                                <div className="text-xs text-gray-500 w-36" title="Blagajna izdavanja">{sale.invoice_space_name || sale.invoice_device_name || ''}</div>
                                                                <div className="text-sm text-gray-500 w-40">{sale.invoice_date || sale.sale_date}</div>
                                                                <div className="text-sm font-bold text-gray-900 w-28">{sale.invoice_total_with_tax} {sale.invoice_currency_symbol}</div>
                                                                <div className="text-sm text-gray-500 w-24">{sale.invoice_payment_method}</div>
                                                                <div className={`inline-block px-2 py-0.5 rounded text-xs font-medium ${
                                                                    sale.status === 1 ? 'bg-green-100 text-green-800' :
                                                                    sale.status === 0 ? 'bg-red-100 text-red-800' :
                                                                    'bg-yellow-100 text-yellow-800'
                                                                }`}>
                                                                    {sale.status === 1 ? 'Aktivan' : sale.status === 0 ? 'Storniran' : 'Storno'}
                                                                </div>
                                                            </div>
                                                            <svg className={`w-5 h-5 text-gray-400 transition-transform ${expandedResult === sale.id ? 'rotate-180' : ''}`}
                                                                fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                                                            </svg>
                                                        </div>

                                                        {expandedResult === sale.id && (
                                                            <div className="px-4 pb-4 bg-white">
                                                                {sale.invoice_company && (
                                                                    <div className="mb-3 text-sm text-gray-600">
                                                                        <span className="font-medium">Kupac:</span> {sale.invoice_company}
                                                                        {sale.invoice_oib ? ` (OIB: ${sale.invoice_oib})` : ''}
                                                                    </div>
                                                                )}

                                                                {sale.note && (
                                                                    <div className="mb-3 text-sm text-gray-500">
                                                                        <span className="font-medium">Napomena:</span> {sale.note}
                                                                    </div>
                                                                )}

                                                                {sale.invoice_items && sale.invoice_items.length > 0 && (
                                                                    <div className="mb-3">
                                                                        <table className="w-full text-sm">
                                                                            <thead>
                                                                                <tr className="border-b border-gray-200">
                                                                                    <th className="text-left py-1.5 text-xs text-gray-500 uppercase">Proizvod</th>
                                                                                    <th className="text-right py-1.5 text-xs text-gray-500 uppercase">Kol.</th>
                                                                                    <th className="text-right py-1.5 text-xs text-gray-500 uppercase">Cijena</th>
                                                                                    <th className="text-right py-1.5 text-xs text-gray-500 uppercase">Ukupno</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {sale.invoice_items.map((item, i) => (
                                                                                    <tr key={i} className="border-b border-gray-100">
                                                                                        <td className="py-1.5 text-gray-700">{item.item_name}</td>
                                                                                        <td className="py-1.5 text-right text-gray-600">{item.item_quantity}</td>
                                                                                        <td className="py-1.5 text-right text-gray-600">{item.item_price_with_tax}</td>
                                                                                        <td className="py-1.5 text-right font-medium text-gray-800">{item.total_item_price_with_tax}</td>
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                )}

                                                                <div className="flex gap-2 flex-wrap">
                                                                    <button onClick={() => printReceipt(sale)}
                                                                        className="bg-blue-600 hover:bg-blue-800 text-white py-2 px-4 rounded text-sm font-medium">
                                                                        Ispis
                                                                    </button>

                                                                    {sale.invoice_real_id && (
                                                                        <button onClick={() => getPdf(sale.invoice_pdf)}
                                                                            className="bg-green-600 hover:bg-green-800 text-white py-2 px-4 rounded text-sm font-medium">
                                                                            PDF
                                                                        </button>
                                                                    )}

                                                                    {sale.status == 1 && (
                                                                        <>
                                                                        <button onClick={() => { setPartialStornoSale(sale); setShowPartialStornoModal(true) }}
                                                                            className="bg-orange-500 hover:bg-orange-700 text-white py-2 px-4 rounded text-sm font-medium">
                                                                            Djelomični storno
                                                                        </button>
                                                                        <button onClick={() => openStornModal(sale)}
                                                                            className="bg-red-600 hover:bg-red-800 text-white py-2 px-4 rounded text-sm font-medium">
                                                                            Storniraj
                                                                        </button>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <PartialStornoModal
                show={showPartialStornoModal}
                sale={partialStornoSale}
                onSuccess={() => {
                    setShowPartialStornoModal(false)
                    setPartialStornoSale(null)
                    // Refresh: update the item in search results
                    if (partialStornoSale) {
                        setSearchResults(prev => prev.map(s => {
                            if (s.id === partialStornoSale.id) {
                                // Update item_quantity_return on items
                                return {...s}
                            }
                            return s
                        }))
                    }
                    setExpandedResult(null)
                }}
                onClose={() => {
                    setShowPartialStornoModal(false)
                    setPartialStornoSale(null)
                }}
            />

            {/* Storno Confirmation Modal */}
            {showStornModal && stornSaleItem && (
                <div className="fixed w-full h-screen left-0 top-0 z-50 flex flex-wrap justify-center content-center p-24">
                    <div onClick={closeStornModal} className="fixed w-full h-screen left-0 top-0 z-0 bg-black bg-opacity-60"></div>
                    <div className="w-96 rounded-lg bg-white shadow-xl overflow-hidden z-10">
                        <div className="p-6">
                            <div className="text-center mb-4">
                                <div className="flex justify-center mb-3">
                                    <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
                                        <svg className="w-7 h-7 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                    </div>
                                </div>
                                <h3 className="text-lg font-semibold text-gray-800">Storniranje računa</h3>
                                <p className="text-gray-500 mt-1">Račun #{stornSaleItem.id}</p>
                                <p className="text-xl font-bold text-gray-900 mt-2">{stornSaleItem.invoice_total_with_tax} {stornSaleItem.invoice_currency_symbol}</p>
                            </div>

                            {stornSaleItem.invoice_device_id && global?.invoiceDevice?.id && stornSaleItem.invoice_device_id !== global.invoiceDevice.id && (
                                <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 mb-4 text-sm text-yellow-800">
                                    Račun je izdan na blagajni <strong>{stornSaleItem.invoice_space_name || stornSaleItem.invoice_device_name}</strong>.
                                    Storno se izdaje na ovoj blagajni, a roba se vraća na skladište ove poslovnice.
                                </div>
                            )}

                            {hasCardPayment(stornSaleItem) && (
                                <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 mb-4">
                                    <div className="flex items-start">
                                        <svg className="w-5 h-5 text-blue-500 mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                                        </svg>
                                        <div>
                                            <p className="text-sm font-semibold text-blue-800">Kartično plaćanje</p>
                                            <p className="text-sm text-blue-600 mt-0.5">Povrat na karticu kupca će se izvršiti automatski.</p>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <p className="text-sm text-gray-500 text-center mb-4">
                                Jeste li sigurni da želite stornirati ovaj račun? Ova radnja se ne može poništiti.
                            </p>

                            <div className="flex gap-2">
                                <button
                                    onClick={closeStornModal}
                                    className="flex-1 py-2.5 px-4 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg font-medium transition-colors"
                                >
                                    Odustani
                                </button>
                                <button
                                    onClick={confirmStorn}
                                    disabled={processing}
                                    className="flex-1 py-2.5 px-4 bg-red-600 hover:bg-red-700 text-white rounded-lg font-medium transition-colors"
                                >
                                    {processing ? 'Procesuiranje...' : 'Storniraj'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}
